import { logger } from '@services/logger/logger.service';
import { generateTraceContext } from '@services/tracing/tracing.service';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function RouterLogger() {
  const location = useLocation();

  useEffect(() => {
    const ctx = generateTraceContext();
    logger.info('ROUTER', 'Navigation', {
      pathname: location.pathname,
      search: location.search,
      trace_id: ctx.trace_id,
      span_id: ctx.span_id,
    });
  }, [location.pathname]);

  return null;
}
